import { Component, OnInit } from '@angular/core';
import {AppService} from '../app.service';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-welcome-email',
  templateUrl: './welcome-email.component.html',
  styleUrls: ['./welcome-email.component.scss']
})
export class WelcomeEmailComponent implements OnInit {

  params: any;
  constructor(private appService: AppService,private route: ActivatedRoute,private router: Router) { 
    this.route.queryParams.subscribe(params => {
      this.params = params;
    });
  }

  ngOnInit(): void {
    if (this.params.id && this.params.code) {
      this.callWelcomeEmail();
    } else {
      this.router.navigate(['/']);
    }
  }

  callWelcomeEmail() {
    this.appService.verifyEmail(this.params.id, this.params.code).then((message) => {
    });
    this.router.navigate(['/'])
  }

}
